import React from 'react';

const GamePlinko = ({ style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.3806 3.59941C11.174 2.49836 12.8252 2.49852 13.6189 3.59941L13.696 3.71367L22.5876 17.9402C23.3936 19.2306 22.5201 20.8922 21.0368 20.9949L20.8913 20.9998H3.10811L2.9626 20.9949C1.47951 20.892 0.605875 19.2305 1.41182 17.9402L10.3034 3.71367L10.3806 3.59941ZM12.4235 4.50859C12.2399 4.21511 11.8271 4.196 11.6149 4.45292L11.5759 4.50859L2.68428 18.7352C2.47645 19.068 2.71569 19.4995 3.10811 19.4998H20.8913C21.2593 19.4997 21.4927 19.1204 21.3493 18.7986L21.3151 18.7352L12.4235 4.50859ZM7.49971 17.9998H5.99971V15.9998H7.49971V17.9998ZM10.9997 17.9998H9.49971V15.9998H10.9997V17.9998ZM14.4997 17.9998H12.9997V15.9998H14.4997V17.9998ZM17.9997 17.9998H16.4997V15.9998H17.9997V17.9998ZM9.24971 14.9998H7.74971V12.9998H9.24971V14.9998ZM12.7497 14.9998H11.2497V12.9998H12.7497V14.9998ZM16.2497 14.9998H14.7497V12.9998H16.2497V14.9998ZM10.9997 11.9998H9.49971V9.9998H10.9997V11.9998ZM14.4997 11.9998H12.9997V9.9998H14.4997V11.9998ZM12.7497 8.9998H11.2497V6.9998H12.7497V8.9998Z",
      fill: "white"
    }
  )
);

export { GamePlinko };
//# sourceMappingURL=GamePlinko.js.map
